<template>
  <div>
    <div class="flex a-center j-center"
         style="height: 60px;background-color: #F7F9FD;box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.1600), 0px 0px 6px 0px rgba(0,0,0,0.1200);">
      <span class="bold fs-16">联系我们</span>
    </div>
    <Row class="m-t-1" style="min-height: 440px">
      <Col span="8" style="background: rgba(75,138,255,0.0500);box-shadow: 0px 4px 12px 0px rgba(0,0,0,0.1600);">
        <div class="flex-column a-start j-start p-t-20">
          <div class="flex a-center j-start w-full p-h-50 p-v-15">
            <img alt="" src="../../../assets/about/ic_phone.png" style="width: 42px;height: 42px">
            <div class="p-l-20 flex-column" style="height: 42px;align-items: flex-start;justify-content: space-between">
              <div>
                客服电话
              </div>
              <div>
                0536-8888999
              </div>
            </div>
          </div>
          <div class="flex a-center j-start w-full p-h-50 p-v-15">
            <img alt="" src="../../../assets/about/ic_qq.png" style="width: 42px;height: 42px">
            <div class="p-l-20 flex-column" style="height: 42px;align-items: flex-start;justify-content: space-between">
              <div>
                客服QQ
              </div>
              <div>
                102338876
              </div>
            </div>
          </div>
          <div class="flex a-center j-start w-full p-h-50 p-v-15">
            <img alt="" src="../../../assets/about/ic_email.png" style="width: 42px;height: 42px">
            <div class="p-l-20 flex-column" style="height: 42px;align-items: flex-start;justify-content: space-between">
              <div>
                邮箱地址
              </div>
              <div>
                shdlaodao@163.com
              </div>
            </div>
          </div>
          <div class="flex a-top j-start w-full p-h-50 p-v-15">
            <img alt="" src="../../../assets/about/ic_wechat.png" style="width: 42px;height: 42px">
            <div class="p-l-15 flex-column">
              <img alt="" src="../../../assets/qr.png" style="width: 96px;height: 96px">
              <div class="m-t-5">
                扫码加微信
              </div>
            </div>
          </div>
        </div>

      </Col>
      <Col span="16" style="background-color:#FFFFFF">
        <div class="p-v-40 p-h-50">
          <Row :gutter="36">
            <Col span="12">
              <div>
                您的姓名
              </div>
              <div class="m-t-10">
                <Input class="inputNoBorder b-b" placeholder="输入姓名"></Input>
              </div>
            </Col>
            <Col span="12">
              <div>
                您的联系电话
              </div>
              <div class="m-t-10">
                <Input class="inputNoBorder b-b" placeholder="输入联系电话"></Input>
              </div>
            </Col>
          </Row>
          <div class="m-t-20">
            <div>
              您的单位名称
            </div>
            <div class="m-t-10">
              <Input class="inputNoBorder b-b" placeholder="请输入单位名称"></Input>
            </div>
          </div>
          <div class="m-t-20">
            <div>
              留言信息
            </div>
            <div class="m-t-10">
              <Input :autosize="{minRows: 3,maxRows: 5}" class="inputNoBorder b-b" placeholder="请输入留言内容"
                     type="textarea"></Input>
            </div>
          </div>
          <div class="m-t-50 flex a-center j-center">
            <Button @click="onCancelClick" class="m-r-15">取消</Button>
            <Button @click="onConfigOKClick" class="m-l-15" type="primary">提交</Button>
          </div>
        </div>
      </Col>
    </Row>
  </div>
</template>

<script>
export default {
  name: 'AboutUsWidget',
  data () {
    return {}
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {

    },
    onCancelClick () {
      this.$emit('cancel')
    },
    onConfigOKClick () {
      this.$emit('config')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
